module.exports = __webpack_public_path__ + "static/media/wgs1.png.1570d367.jpg";